import { AfterViewInit, Component, Inject, ModelFunction, Optional, ViewChild, model } from '@angular/core';
import moment from 'moment';

import { CryptoModel } from '../crypto.model';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CryptoModifyComponent } from '../modify/modify.component';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';
import { SharesService } from '../../shares/shares.service';
import { MarketDataService } from '../market-data.service';


@Component({
  selector: 'crypto-create',
  standalone: false,
  templateUrl: './create.component.html',
  styleUrl: './create.component.scss'
})
export class CryptoCreateComponent implements AfterViewInit {
  
  public crypto: any
  public shares: any

  @ViewChild('createForm', { static: true }) createForm: NgForm | undefined
  public errorMessage: any
  public loadingMarketData = false
  
  constructor(
    private dialogRef: MatDialogRef<CryptoModifyComponent>,
    private currencyPipe: CurrencyPipe,
    private shareService: SharesService,
    private marketData: MarketDataService
  ){
    this.crypto = {
      id: Math.random().toFixed(3),
      share: '',
      date: new Date(),
      side: '',
      amount: 0,
      price: 0.00,
      tax: 0.00,
      total: 0.00,
      usdBrl: null,
      btcUsd: null
    }
  }

  async ngAfterViewInit(): Promise<void> {
    console.error('CryptoCreateComponent -> ngAfterViewInit')

    //Update total
    this.createForm?.valueChanges?.subscribe((input:any) => {
      console.error('CryptoCreateComponent -> createForm.valueChanges', input['crypto.amount'], input['crypto.price'], input['crypto.tax'])

      if(input['crypto.amount'] != undefined && input['crypto.price'] != undefined && input['crypto.tax'] != undefined )
        this.crypto.total = ((parseFloat(input['crypto.amount']) * parseFloat(this.currencyPipe.transform(input['crypto.price'], false))) + parseFloat(this.currencyPipe.transform(input['crypto.tax'], false))).toFixed(2)
    })
    
    this.loadMarketData(this.crypto.date)

    this.shares = await this.shareService.loadOptions('CRYPTO')
    console.error('ShareCreateComponent -> ngAfterViewInit', 'shares', this.shares)
  }

  // Quotes of the operation date; the user can still adjust them manually
  async loadMarketData(date: any): Promise<void> {
    if (!date) return
    const d = moment(date).toDate()

    this.loadingMarketData = true
    const [usdBrl, btcUsd] = await Promise.all([this.marketData.getUsdBrl(d), this.marketData.getBtcUsd(d)])
    this.crypto.usdBrl = usdBrl
    this.crypto.btcUsd = btcUsd
    this.loadingMarketData = false
  }

  async onSubmit() {
    console.error('CryptoCreateComponent -> onSubmit', this.crypto, this.createForm?.valid)

    if (this.createForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Crypto created!',
          values: { 
            ...this.crypto, 
            amount: parseFloat(this.createForm.value['crypto.amount']), 
            price: parseFloat(this.currencyPipe.transform(this.createForm.value['crypto.price'], false)),
            tax: parseFloat(this.currencyPipe.transform(this.createForm.value['crypto.tax'], false)),
            total: parseFloat(this.currencyPipe.transform(this.createForm.value['crypto.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
  
}
